import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLocations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/suite-location', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteLocation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/suite-location/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
